import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useDepots, fmtDepot } from "@/lib/depots";
import { Warning, Bus, MapPin } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function BackupBusWidget() {
  const depotMap = useDepots();
  const [buses, setBuses] = useState([]);
  const [target, setTarget] = useState(null);
  const [suggestions, setSugg] = useState([]);

  useEffect(()=>{ api.get("/fleet/buses").then(({data})=>{
    const b = data.filter(x=>x.status==="Breakdown"); setBuses(b);
    if (b[0]) loadFor(b[0]);
  }); }, []);

  const loadFor = async (b) => {
    setTarget(b);
    const { data } = await api.get(`/fleet/backup-suggestions?broken_bus_id=${b.id}&limit=5`);
    setSugg(data);
  };

  const dispatch = async (s) => {
    try {
      const { data } = await api.post("/dispatch/backup", { broken_bus_id: target.id, backup_fleet_id: s.fleet_id });
      toast.success(`${s.fleet_id} dispatched · trip transferred · driver notified · passenger SMS sent`);
      // Reload broken list
      api.get("/fleet/buses").then(({data})=>{ const b = data.filter(x=>x.status==="Breakdown"); setBuses(b); if (b[0]) loadFor(b[0]); else { setTarget(null); setSugg([]); } });
    } catch { toast.error("Dispatch failed"); }
  };

  return (
    <div className="ktcl-card p-4">
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="min-w-0">
          <div className="label-cap text-slate-500 flex items-center gap-1.5"><Warning size={12} className="text-[#EF4444]"/>Breakdown Response</div>
          <h3 className="font-display text-base sm:text-lg font-bold leading-tight">Backup Bus Suggestions</h3>
        </div>
        {buses.length > 0 && <span className="shrink-0 text-[10px] sm:text-xs px-2 py-0.5 bg-red-50 text-red-700 rounded font-semibold whitespace-nowrap">{buses.length} broken</span>}
      </div>
      {buses.length === 0 && <div className="text-sm text-slate-500 py-6 text-center">No breakdowns reported — fleet healthy.</div>}
      {buses.length > 0 && (
        <>
          <div className="flex gap-2 overflow-auto scroll-thin pb-2 mb-3">
            {buses.map(b=>(
              <button key={b.id} onClick={()=>loadFor(b)}
                className={`shrink-0 px-3 py-1.5 border rounded-md text-xs ${target?.id===b.id?"border-[#EF4444] bg-red-50 font-semibold text-red-700":"border-slate-200"}`}>
                {b.fleet_id} · {fmtDepot(b.depot, depotMap)}
              </button>
            ))}
          </div>
          <div className="space-y-2 max-h-72 overflow-auto scroll-thin">
            {suggestions.map((s,i)=>(
              <div key={s.fleet_id} className={`p-2.5 border rounded-md hover:bg-slate-50 ${i===0?"border-[#22C55E] bg-green-50/30":"border-slate-200"}`}>
                <div className="flex items-center gap-2 mb-1">
                  <div className={`w-7 h-7 rounded flex items-center justify-center text-xs font-bold shrink-0 ${i===0?"bg-[#22C55E] text-white":"bg-slate-100 text-slate-600"}`}>{i+1}</div>
                  <Bus size={16} weight="duotone" className="text-[#1E3A8A] shrink-0"/>
                  <span className="font-mono font-bold text-sm text-[#1E3A8A]">{s.fleet_id}</span>
                  {s.same_depot && <span className="text-[10px] px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded">Same Depot</span>}
                </div>
                <div className="text-xs text-slate-600 truncate pl-9">{s.registration_number} · {fmtDepot(s.depot, depotMap)} · {s.category}</div>
                <div className="flex items-center justify-between gap-2 mt-2 pl-9">
                  <div className="text-xs text-slate-700 flex items-center gap-2 flex-wrap">
                    <span className="font-semibold inline-flex items-center gap-1"><MapPin size={11}/>{s.distance_km} km</span>
                    <span className="text-slate-500">ETA {s.eta_min}m</span>
                    <span className="text-slate-500">🔋{s.soc}%</span>
                  </div>
                  <button onClick={()=>dispatch(s)} className="ktcl-btn-primary px-3 py-1.5 rounded text-xs font-semibold shrink-0">Dispatch</button>
                </div>
              </div>
            ))}
            {suggestions.length === 0 && <div className="text-xs text-slate-500 text-center py-4">No available backup buses nearby.</div>}
          </div>
        </>
      )}
    </div>
  );
}
